export default "/images/topdanmark-min-org.webp?71e7f2e997163d04dd3d716ff7fa2fd1";